import { Box, Paper } from '@mui/material';
import React, { FC, useMemo } from 'react';
import { BaseScreen } from '../../../Components/Templates/BaseScreen/basescreen.component';
import { BaseContentPage } from '../../../Components/Templates/BaseContentPage/base-content-page.componen';
import { Button } from '../../../Components/Form/Button/button.scomponent';
import { GoPlus } from "react-icons/go";
import { Table } from '../../../Components/Table/table.component';
import { Link, useNavigate } from 'react-router-dom';
import { ListProductUseCase } from '../../../Usecase/Products/list-product-usecase';
import { useListProducts } from './products-list.hook';
import { Placeholder } from '../../../Components/Placeholder/placeholder.component';
import { TableListSkeleton } from '../../../Components/Table/table-list-skeleton.component';
import { Can } from '../../../Components/Can';
import { IoFileTrayOutline, IoFilterOutline } from 'react-icons/io5';
import { ButtonActionMenu } from '../../../Components/Form/ButtonActionsMenu/button-action-menu.component';
import { FaBox, FaEdit, FaTrash } from 'react-icons/fa';
import { ConfirmDialog } from '../../../Components/Dialog/variants/dialog-confirmation/dialog-confirmation.component';
import { DestroyProductUseCase } from '../../../Usecase/Products/destroy-product-usecase';
import { ProductsFilterDrawer } from '../../../Components/Drawer/variants/products-filter/products-filter-drawer.component';
import { ExportExcelProductUseCase } from '../../../Usecase/Products/export-excel-product-usecase';
import { buildProductCreateUrl, buildProductFormUrl } from '../../../utils/products-list-url';

interface IProductsList {
    listProductUseCase: ListProductUseCase
    destroyProductUseCase: DestroyProductUseCase
    exportExcelProductUseCase: ExportExcelProductUseCase
}
const ProductsList : FC<IProductsList> = ({ listProductUseCase, destroyProductUseCase, exportExcelProductUseCase }) => {
    const navigate = useNavigate()

    const {
      list,
      totalRegisters,
      loading,
      loadError,
      listProdcuts,
      setShowFiltersModal,
      showFiltersModal,
      setItemToDestroy,
      itemToDestroy,
      handleFilterSelect,
      handleDestroyProduct,
      currentFilters,
      handleExportExcel,
      handlePageChangeProducts,
      handleSearch,
      listReturnUrl,
    } = useListProducts({
        listProductUseCase,
        destroyProductUseCase,
        exportExcelProductUseCase
    })

    const columns = useMemo(() => {
        const createColumns: any[] = [
          {
            field: 'photo',
            headerName: 'Imagem',
            width: 100,
            sortable: false,
            renderCell: (params: any) => (
              <Box
                component='img'
                src={params.value}
                alt=""
                sx={{ width: '72px', height: '72px', objectFit: 'contain' }}
              />
            ),
          },
          {
            field: 'internalName',
            headerName: 'Nome Importado',
            flex: 1,
            minWidth: 140,
            renderCell: (params: any) => (
              <Box
                component={Link}
                to={buildProductFormUrl(params.row.id, listReturnUrl)}
                sx={{
                  color: 'inherit',
                  textDecoration: 'none',
                  '&:hover': { textDecoration: 'underline' },
                  whiteSpace: 'normal',
                  wordBreak: 'break-word',
                  lineHeight: 1.4,
                }}
              >
                {params.value}
              </Box>
            ),
          },
          {
            field: 'name',
            headerName: 'Nome Amigável',
            flex: 1,
            minWidth: 140,
            renderCell: (params: any) => (
              <Box sx={{ whiteSpace: 'normal', wordBreak: 'break-word', lineHeight: 1.4 }}>
                {params.value}
              </Box>
            ),
          },
          {
            field: 'code',
            headerName: 'Código',
            width: 120
          },
          {
            field: 'b2bNuvemShopPrice',
            headerName: 'Preço - B2B',
            width: 140
          },
          {
            field: 'b2cNuvemShopPrice',
            headerName: 'Preço - B2C',
            width: 140
          },
          {
            field: "actions",
            headerName: "Ações",
            width: 80,
            sortable: false,
            renderCell: (params: any) => (
              <ButtonActionMenu
                options={[
                  {
                    title: 'Editar',
                    href: buildProductFormUrl(params.row.id, listReturnUrl),
                    icon: <FaEdit size={18} />
                  },
                  {
                    title: 'Ver Estoque',
                    href: `/stocks-details/${params.row.id}`,
                    icon: <FaBox size={18} />
                  },
                  {
                    title: 'Excluir',
                    onClick: () => setItemToDestroy(params.row),
                    titleColor: 'error.main',
                    icon: <FaTrash size={18} />
                  }
                ]}
              />
            ),
          }
        ];

        return createColumns;
      }, [listReturnUrl, setItemToDestroy]);

    return (
      <Can permissions={['menu:products:manage']}>
        <ConfirmDialog
          title='Remover Produto'
          onCancel={() => setItemToDestroy(undefined)}
          description={`Tem certeza que deseja remover "${itemToDestroy?.internalName || itemToDestroy?.name || 'este produto'}"?`}
          open={!!itemToDestroy}
          onConfirm={handleDestroyProduct}
        />
        <BaseScreen>
            <Paper sx={{ borderRadius: 2, overflow: 'hidden', width: '100%' }}>

                <ProductsFilterDrawer
                  handleSelect={handleFilterSelect}
                  open={showFiltersModal}
                  title='Filtros'
                  onToggle={() => setShowFiltersModal(prev => !prev)}
                />
                <BaseContentPage
                    title='Produtos'
                    minHeight="auto"
                    search
                    searchDefaultValue={currentFilters.searchBy ?? ''}
                    searchFunction={handleSearch}
                    searchLoading={loading && !!list?.length}
                    placeholderSearch='Pesquisar por nome ou código'
                    breadcrumb={[{ title: 'Produtos', link: "/products-list"}, { title: 'Listagem'}]}
                    Action={() => (
                      <Button
                        LeftIcon={() => <GoPlus size={18} />}
                        sx={{ width: { xs: '100%', sm: 'auto' }, minWidth: { sm: 130 }, flexShrink: 0 }}
                        boxLeftSx={{ gap: '10px', marginLeft: '5px' }}
                        textSx={{ textTransform: 'Capitalize', fontWeight: 500, whiteSpace: 'nowrap' }}
                        onClick={() => navigate(buildProductCreateUrl(listReturnUrl))}
                      >
                        Adicionar
                      </Button>
                    )}
                    toolbarActions={() => (
                      <>
                        <Button
                          LeftIcon={() => <IoFilterOutline size={18} />}
                          sx={{ width: { xs: '100%', sm: 'auto' }, minWidth: { sm: 100 }, flexShrink: 0 }}
                          boxLeftSx={{ gap: '10px', marginLeft: '5px' }}
                          textSx={{ textTransform: 'Capitalize', fontWeight: 500, whiteSpace: 'nowrap' }}
                          onClick={() => setShowFiltersModal(true)}
                        >
                          Filtros
                        </Button>
                        <Button
                          LeftIcon={() => <IoFileTrayOutline size={18} />}
                          sx={{ width: { xs: '100%', sm: 'auto' }, minWidth: { sm: 100 }, flexShrink: 0 }}
                          boxLeftSx={{ gap: '10px', marginLeft: '5px' }}
                          textSx={{ textTransform: 'Capitalize', fontWeight: 500, whiteSpace: 'nowrap' }}
                          onClick={handleExportExcel}
                        >
                          Excel
                        </Button>
                      </>
                    )}
                >
                  {!!list?.length ? (
                    <Box sx={{ width: '100%', minWidth: 0 }}>
                      <Table
                        data={list}
                        columns={columns}
                        onPageChange={handlePageChangeProducts}
                        totalCount={totalRegisters}
                        search={currentFilters.searchBy}
                        page={currentFilters.page}
                        rowHeight={88}
                        stickyHeader
                        maxHeight="calc(100vh - 280px)"
                      />
                    </Box>
                  ) : loading ? (
                    <TableListSkeleton rowHeight={88} />
                  ) : loadError ? (
                    <Placeholder
                      description="Não foi possível carregar os produtos."
                      onRetry={() => listProdcuts({ page: currentFilters.page })}
                    />
                  ) : (
                    <Placeholder description="Nenhum produto encontrado." />
                  )}
                </BaseContentPage>

            </Paper>

        </BaseScreen>
        </Can>
    )
}

export { ProductsList };
